<template>
  <q-card flat style="min-width: 400px">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>صدور اسناد مالی بارنامه </span>
        <template v-slot:action>
          <q-btn flat round icon="close" v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-card flat class="shadow-10">
        <q-card-section class="no-padding">
          <q-badge v-if="wayBillInfo.DIFF!==0" rounded :label="`${wayBillInfo.DIFF} روز پیش`"
                   :color="wayBillInfo.DIFF<=30?'green-14':'red-14'" text-color="white"/>
          <q-badge v-if="wayBillInfo.DIFF===0" rounded :label="`امروز`"
                   color="green-14" text-color="white"/>
          <q-space/>
          <q-badge class="q-ml-xs" rounded color="green-10 text-white" v-if="wayBillInfo.HasFinanceDocument"
                   label="سند مالی صادر شده است"/>
          <q-badge class="q-ml-xs" rounded color="green-10 text-white" v-if="wayBillInfo.IsPay"
                   label="پرداخت شده"/>
          <q-chip size="sm" icon="attach_file" color="blue-grey" flat round
                  clickable
                  label="ضمیمه دارد"
                  text-color="white"
                  @click="downloadAttachment(wayBillInfo)"
                  v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                                && wayBillInfo.HasAttachment">
            <q-tooltip>
              دانلود ضمیمه
            </q-tooltip>
          </q-chip>
        </q-card-section>
        <q-card-section class="no-padding">
          <q-chip dense square icon="pin" color="purple" text-color="white" :label="wayBillInfo.WayBillNumber">

          </q-chip>
        </q-card-section>
        <q-card-section class="no-padding">
          <q-chip dense square :label="wayBillInfo.UserName" icon="support_agent">
            <q-tooltip>
              صادر کننده بارنامه
            </q-tooltip>
          </q-chip>
          <q-chip dense square :label="wayBillInfo.Visitor_Name" icon="person"/>
          <q-card-section v-if="wayBillInfo.Sale_Nums && wayBillInfo.Sale_Nums!==''" class="no-padding">
            <q-space v-if="lodash.uniq(wayBillInfo.Sale_Nums.map(item=>item.City_Name)).length>1"/>
            <q-chip dense square
                    v-for="(item, index) in lodash.uniq(wayBillInfo.Sale_Nums.map(rec=>rec.City_Name))"
                    :label="item" :key="index" icon="location_city"/>
          </q-card-section>
          <q-space/>
          <q-chip dense square color="red" text-color="white" icon="calendar_today"
                  :label="wayBillInfo.WayBillDateTime">
            <q-tooltip>
              تاریخ ثبت
            </q-tooltip>
          </q-chip>
          <q-space v-if="wayBillInfo.TransferDateTime"/>
          <q-chip dense v-if="wayBillInfo.TransferDateTime" square color="deep-orange" text-color="white"
                  icon="local_shipping"
                  :label="wayBillInfo.TransferDateTime">
            <q-tooltip>
              تاریخ ارسال بار
            </q-tooltip>
          </q-chip>
        </q-card-section>
        <q-card-section class="text-center no-padding">
          <table class="no-padding no-margin">
            <thead class="text-center text-bold" style="margin: 0;padding: 0">
            <tr>
              <td>کرایه راننده</td>
              <td>کرایه زیرفاکتور</td>
              <td>
                مبلغ بار
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-center" style="padding: 0;margin: 0">
                <q-badge v-if="wayBillInfo.TransferCost" class="q-ml-xs" color="red" text-color="white"
                         :label="wayBillInfo.TransferCost.toLocaleString()"/>
              </td>
              <td class="text-center" style="padding: 0;margin: 0">
                <q-badge v-if="wayBillInfo.Transpose_Cost" class="q-ml-xs" color="red" text-color="white"
                         :label="wayBillInfo.Transpose_Cost.toLocaleString()"/>
              </td>
              <td class="text-center" style="padding: 0;margin: 0">
                <q-badge class="q-ml-xs" color="green" text-color="white"
                         :label="lodash.sumBy(wayBillInfo.Sale_Nums,'Sale_Pay').toLocaleString()"/>
              </td>
            </tr>
            </tbody>
          </table>
        </q-card-section>
        <q-card-section class="no-padding" v-if="wayBillInfo.Sale_Nums===''">
          {{ wayBillInfo.Title }}
        </q-card-section>
        <q-card-section>
          <q-list bordered>
            <q-item v-for="(item, index) in flow" :key="index">
              <q-item-section avatar>
                <q-icon :color="item.value?'green':'red'" :name="item.value?'check_circle':'cancel'"/>
              </q-item-section>

              <q-item-section>{{ item.title }}</q-item-section>
              <q-item-section side>
                <q-btn icon="request_page" flat round @click="sendRequest(item.name)"
                       v-if="!item.value && !inProcess
                       && ((parseInt($store.state.balanceInfo)-parseInt(wayBillInfo.TransferCost))>0) || (item.name==='AddFinanceDocument' && !item.value)">
                  <q-tooltip>
                    ارسال درخواست
                  </q-tooltip>
                </q-btn>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
      </q-card>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "WayBillPayment",
  props: {
    wayBillInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    }
  },
  data() {
    return {
      flow: [
        {name: "AddFinanceDocument", value: this.wayBillInfo.HasFinanceDocument, title: "صدور سند هزینه بارنامه"},
        {name: "Pay", value: this.wayBillInfo.IsPay, title: "پرداخت هزینه بارنامه"},
        {name: "AddPayDocument", value: this.wayBillInfo.IsPay, title: "صدور سند پرداخت بارنامه"}
      ],
      originKey: undefined,
      inProcess: false,
    }
  },
  components: {},
  methods: {
    ...mapActions({
      addPayDocument: 'Drivers/addPayFinanceDocument',
      addDocument: 'Drivers/addDocumentFinanceDocument',
      instancePayment: 'Finnotech/instancePayment',
      SendSMS: 'Finnotech/sendFinnotechSms',
    }),
    sendRequest(name) {
      if (name === "AddFinanceDocument") {
        this.inProcess = true
        this.addDocument({
          wayBillNumber: this.wayBillInfo.WayBillNumber,
        }).then((res) => {
          if (res.data.isIssueFinance > -1) {
            const foundedIndex = this.flow.findIndex(x => x.name === name)
            this.flow[foundedIndex].value = true
            this.$emit('issue-finance-document', this.wayBillInfo.WayBillNumber)
            this.inProcess = false
          }
        })
      } else if (name === "Pay") {
        this.inProcess = true
        this.$q.dialog({
          title: 'تاییدیه',
          message: 'مبلغ بارنامه پرداخت شود؟',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.instancePayment({
            instancePaymentBody: {
              amount: parseInt(this.wayBillInfo.TransferCost),
              description: `بابت بارنامه ${this.wayBillInfo.WayBillNumber.toString()}`,
              reasonDescription: "16",
              destinationFirstname: this.wayBillInfo.Visitor_Name,
              destinationLastname: this.wayBillInfo.Visitor_Name,
              destinationNumber: this.wayBillInfo.Shaba
            },
            walletName: "WayBillWallet"
          }).then((res) => {
            if ('status' in res) {
              if (res.status === "DONE") {
                this.$q.notify({
                  type: 'positive',
                  position: 'top',
                  message: 'مبلغ بارنامه به راننده پرداخت شد'
                })
                const foundedIndex = this.flow.findIndex(x => x.name === "Pay")
                this.flow[foundedIndex].value = true
                this.originKey = res.result.originKey
                this.$store.state.balanceInfo -= parseInt(this.wayBillInfo.TransferCost)
                this.addPayDocument({
                  wayBillNumber: this.wayBillInfo.WayBillNumber,
                  receiptNumber: res.result.originKey
                }).then((res) => {
                  if (res.data.isPay > -1) {
                    this.$emit('pay-finance-document', this.wayBillInfo.WayBillNumber)
                    this.$q.notify({
                      type: 'positive',
                      position: 'top',
                      message: 'سند پرداخت ثبت شد'
                    })
                    this.inProcess = false
                    const foundedIndex = this.flow.findIndex(x => x.name === "AddPayDocument")
                    this.flow[foundedIndex].value = true
                  }
                })
              }
            }
          })
        })
      } else if (name === "AddPayDocument") {
        this.inProcess = true
        this.addPayDocument({
          wayBillNumber: this.wayBillInfo.WayBillNumber,
          receiptNumber: "020418073417KZ077305"//this.originKey
        }).then((res) => {
          if (res.data.isPay > -1) {
            this.$emit('pay-finance-document', this.wayBillInfo.WayBillNumber)
            this.$q.notify({
              type: 'positive',
              position: 'top',
              message: 'سند پرداخت ثبت شد'
            })
            this.inProcess = false
            const foundedIndex = this.flow.findIndex(x => x.name === "AddPayDocument")
            this.flow[foundedIndex].value = true
          }
        })

      }
    }
  },
  computed: {},
  watch: {},
  created() {

  }
}
</script>

<style scoped>

</style>